module.exports = __webpack_public_path__ + "img/avalon-front-angle.5fec6403.png";